<div class="modal-content" style="border-radius: 20px;">
  <div class="row justify-content-between ml-3 mr-3">
    <h1 class="modal-title" style="cursor:default;">{{ title }}</h1>
    <div type="button" (click)="modalRef.hide()">
      <div class="modal-close" aria-hidden="true">
        <h1 style=" font-size: 300%;">&times;</h1>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row no-gutters justify-content-around">
        <div class="item">
          <div class="form-group">
            <label for="venue_name"
              ><h4 class="section-label">VENUE NAME</h4></label
            >
            <input
              type="text"
              class="form-control form-control-lg"
              id="venue_name"
              formControlName="venue_name"
              maxlength="30"
            />
          </div>
          <div class="form-group ">
            <label for="city"><h4 class="section-label">CITY</h4></label>
            <input
              type="text"
              class="form-control form-control-lg grey-text"
              id="city"
              disabled
              placeholder="{{ city }}"
            />
          </div>
          <div class="form-group required">
            <label for="sd"
              ><h4 class="section-label">
                SHORT DESCRIPTION
                <b>({{ form.controls.sd.value.length }}/100)</b>
              </h4></label
            >
            <textarea
              maxlength="100"
              class="form-control"
              id="sd"
              rows="3"
              formControlName="sd"
            ></textarea>
          </div>
          <div class="form-group required">
            <label for="ld"
              ><h4 class="section-label">
                LONG DESCRIPTION
                <b>({{ form.controls.ld.value.length }}/200)</b>
              </h4></label
            >
            <textarea
              maxlength="200"
              class="form-control"
              id="ld"
              rows="4"
              formControlName="ld"
            ></textarea>
          </div>
        </div>
        <div class="item">
          <label for="redirect"
            ><h4 class="section-label">APP REDIRECT</h4></label
          >
          <div id="redirect" class="form-group">
            <div class="form-check form-check-inline">
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  id="redirect_active"
                  formControlName="redirect"
                  [value]="true"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="redirect_active"
                  >Active</label
                >
              </div>
            </div>
            <div class="form-check form-check-inline">
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  id="redirect_inactive"
                  formControlName="redirect"
                  [value]="false"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="redirect_inactive"
                  >Inactive</label
                >
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="venue_name"
              ><h4 class="section-label">REDIRECT URL</h4></label
            >
            <input
              type="text"
              class="form-control form-control-lg "
              [ngClass]="{ disabled: !form.controls.redirect.value }"
              id="redirect_url"
              formControlName="redirect_url"
            />
          </div>

          <label><h4 class="section-label">APP VISIBILITY</h4></label>
          <div class="form-group">
            <div class="form-check form-check-inline">
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  id="visible"
                  formControlName="active"
                  [value]="true"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="visible"
                  >Visible</label
                >
              </div>
            </div>
            <div class="form-check form-check-inline">
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  id="hidden"
                  formControlName="active"
                  [value]="false"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="hidden">Hidden</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="thumbnail-container">
              <h4 class="section-label">
                THUMBNAIL
              </h4>
              <div class="image-container">
                <img src="{{ image }}" *ngIf="imageSelected()" />
                <div class="form-group">
                  <input
                    class="file-input add"
                    type="file"
                    (change)="selectImage($event)"
                    accept=".png,.jpg"
                    *ngIf="!imageSelected()"
                  />
                  <input
                    class="file-input change"
                    type="file"
                    (change)="selectImage($event)"
                    accept=".png,.jpg"
                    *ngIf="imageSelected()"
                  />
                </div>
                <div class="placeholder" *ngIf="!imageSelected()"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div type="submit" class="submit-city-container" (click)="validate()">
      <h4>{{ button }}</h4>
    </div>
  </div>
</div>
